import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * Tailwind merge that knows the MG AI School design tokens, so `cn('text-body', 'text-muted')`
 * keeps both (size vs colour) and `cn('rounded-control', 'rounded-card')` keeps the last.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: [
        'hero',
        'hero-sm',
        'page-title',
        'post-title',
        'section',
        'feed-title',
        'body',
        'prose',
        'meta',
        'tiny',
        'micro',
        'tab',
        'btn',
        'btn-sm',
        'btn-lg',
      ],
      radius: ['card', 'control', 'modal'],
      shadow: ['hover', 'pop'],
    },
  },
})

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
